import { z } from 'zod'
import { Currency } from '../../enums/currency.enum'
import { PaymentType } from '../../enums/payment-type.enum'
import { AccountType } from '../../enums/account-type.enum'
import { depositDetailsResponseSchema } from '../deposits/deposit-details-response.schema'
import { creditDetailsResponseSchema } from '../credit/credit-details-response.schema'

export const accountResponseSchema = z.object({
  id: z.string().guid(),
  name: z.string(),
  // the name this account answers to in a bank statement export (see importAliasSchema)
  importAlias: z.string().nullable(),
  paymentType: z.nativeEnum(PaymentType),
  currency: z.nativeEnum(Currency),
  default: z.boolean(),
  archived: z.boolean(),
  balance: z.number().nullable(),
  order: z.number().int(),
  type: z.nativeEnum(AccountType),
  // whether this account counts toward the accounts-page summary total (broker accounts
  // can be toggled out; all others are always included)
  includeInTotal: z.boolean(),
  depositDetails: depositDetailsResponseSchema.nullable().optional(),
  creditDetails: creditDetailsResponseSchema.nullable().optional(),
  // present only for linked BROKER accounts: portfolio valuation on top of the cash balance.
  // `balance` above stays the sync-authoritative cash; brokerValue adds positions/total.
  brokerValue: z
    .object({
      displayCurrency: z.string(),
      cashValue: z.number(),
      positionsValue: z.number(),
      totalValue: z.number(),
      syncedAt: z.coerce.date(),
    })
    .nullable()
    .optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type AccountResponseDto = z.infer<typeof accountResponseSchema>
